import { lazyRouteComponent } from "@tanstack/react-router";
import { Globe } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const TABS = ["news", "views", "feeds"] as const;
export const HOURS = [6, 24, 72] as const;
export const LEVELS = ["important", "notable"] as const;

export interface DeskSearch {
  tab: (typeof TABS)[number];
  hours: (typeof HOURS)[number];
  level: (typeof LEVELS)[number];
  /** A theme key (war, oil, rates ...). */
  theme?: string;
  /** A story whose outlets are open. */
  story?: number;
}

export function parseDeskSearch(s: Record<string, unknown>): DeskSearch {
  const hours = Number(s.hours);
  const story = Number(s.story);
  const theme =
    typeof s.theme === "string" && /^[a-z_]{1,30}$/.test(s.theme)
      ? s.theme
      : undefined;
  return {
    tab: TABS.includes(s.tab as DeskSearch["tab"])
      ? (s.tab as DeskSearch["tab"])
      : "news",
    hours: (HOURS as readonly number[]).includes(hours)
      ? (hours as DeskSearch["hours"])
      : 24,
    level: LEVELS.includes(s.level as DeskSearch["level"])
      ? (s.level as DeskSearch["level"])
      : "notable",
    ...(theme ? { theme } : {}),
    ...(Number.isInteger(story) && story > 0 ? { story } : {}),
  };
}

export const pages: PageDef[] = [
  {
    path: "/app/desk",
    title: "Market Desk",
    component: lazyRouteComponent(() => import("./DeskPage"), "DeskPage"),
    nav: { label: "Market Desk", icon: Globe, group: "Markets", order: 45 },
    validateSearch: parseDeskSearch,
  },
];
